import React from "react";

/** Super admin: a historical correction updates the resident's ledger only — nothing posts to ...1403 or the Petty Cash drawer. */
export const NoCashToggle = ({ on, set, testid }) => (
  <label className={`flex items-start gap-2 p-2.5 border rounded-sm cursor-pointer text-[12px] transition-colors ${on ? "border-amber-400/60 bg-amber-500/[0.07]" : "border-white/10"}`} data-testid={testid}>
    <input type="checkbox" checked={on} onChange={(e) => set(e.target.checked)} className="mt-0.5 accent-[#d4a017]" data-testid={`${testid}-input`} />
    <span><span className="text-nex-silver font-semibold">Historical correction — no cash movement</span>
      <span className="block text-nex-muted text-[11px]">Fixes past records on the resident's ledger only. Nothing posts to TEA-First Reliance ...1403 or the Petty Cash drawer.</span></span>
  </label>
);
